<div class="search-wrapper" [class.search-nav]="appearance === 'nav'" [class.search-hero]="appearance === 'hero'">
  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      [(ngModel)]="query"
      (ngModelChange)="onQueryChange($event)"
      [placeholder]="placeholder"
      (keydown)="onKeyDown($event)"
      autocomplete="off"
    />
    <button *ngIf="query" mat-icon-button matSuffix (click)="clear()" type="button" aria-label="Clear">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <button *ngIf="appearance === 'hero' && showButton" mat-flat-button color="accent" (click)="onSearch()" type="button" class="search-btn" [disabled]="!query.trim()">
    Search
  </button>
</div>
